module.exports = __webpack_public_path__ + "fabf9a34175f8f1aa6d514449dfe33af.png";